import { useRef } from "react";
import { useGsapFooterHeadline } from "../Hooks/gsap";

const FooterAbout = () => {
  const footerRef = useRef(null);
  const footerHeadline = useRef(null);

  useGsapFooterHeadline(footerHeadline, footerRef);

  return (
    <section className="footer wrapper sectionAbout" ref={footerRef}>
      <h1 ref={footerHeadline}>Ariz Supermart</h1>
      <p>
        &copy; {new Date().getFullYear()} Ariz Supermart. POWERED by ARIZ
      </p>
    </section>
  );
};

export default FooterAbout;
